export default "__VITE_ASSET__580489e4__"